// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicarePlanTypeResponseModel } from './medicarePlanTypeResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicarePayerResponseModel {
    'name'?: string;
    'planTypes'?: Array<MedicarePlanTypeResponseModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicarePayerResponseModel>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "planTypes",
            "baseName": "planTypes",
            "type":     "Array<MedicarePlanTypeResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return MedicarePayerResponseModel.attributeTypeMap;
    }
}
